import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SOCIAL_LINKS } from '@core/constants/util.constants';
import { LanguageService, Languages } from '@core/services/language.service';
import { ResponsiveService } from '@core/services/responsive.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LangToggleComponent } from '../lang-toggle/lang-toggle.component';
import { PbbSvgIconComponent } from '../pbb-svg-icon/pbb-svg-icon.component';

@Component({
    selector: 'pbb-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PbbSvgIconComponent, MatIconModule, LangToggleComponent, TranslateModule]
})
export class FooterComponent {
  @HostBinding('class.responsive-large') responsiveLarge: boolean = false;

  Languages = Languages;
  footerLinks: Array<any> = [
    {
      menuLabel: 'FOOTER.MENU.TITLE_KONEK',
      options: [
        { url: 'FOOTER.MENU_OPTION.SHOPPERS.URL', optionLabel: 'FOOTER.MENU_OPTION.SHOPPERS.LABEL' },
        { url: 'FOOTER.MENU_OPTION.MERCHANTS.URL', optionLabel: 'FOOTER.MENU_OPTION.MERCHANTS.LABEL' },
      ],
    },
    {
      menuLabel: 'FOOTER.MENU.TITLE_POLICIES',
      options: [
        { url: 'FOOTER.MENU_OPTION.COOKIES.URL', optionLabel: 'FOOTER.MENU_OPTION.COOKIES.LABEL' },
        { url: 'FOOTER.MENU_OPTION.PRIVACY.URL', optionLabel: 'FOOTER.MENU_OPTION.PRIVACY.LABEL' },
        { url: 'FOOTER.MENU_OPTION.TERMS.URL', optionLabel: 'FOOTER.MENU_OPTION.TERMS.LABEL' },
      ],
    },
    {
      menuLabel: 'FOOTER.MENU.TITLE_HELP',
      options: [{ url: 'FOOTER.MENU_OPTION.FAQ.URL', optionLabel: 'FOOTER.MENU_OPTION.FAQ.LABEL' }],
    },
  ];

  isPilot: boolean = false;
  islanding: boolean = false;
  socialLinks = SOCIAL_LINKS;

  constructor(
    public translateService: TranslateService,
    public languageService: LanguageService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private responsive: ResponsiveService
  ) {
    this.router.events.subscribe(() => {
      if (this.isPilot !== window.location.href.includes('pilot')) {
        this.isPilot = window.location.href.includes('pilot');
        this.ref.detectChanges();
      }
    });
    this.responsive.responsiveLarge$.subscribe((resLarge) => {
      this.responsiveLarge = resLarge;
    });
  }
}
